import Layout from '@components/layout/Layout';
import HeroSection from '@components/sections/HeroSection';
import FeaturesBar from '@components/sections/FeaturesBar';
import WhyRideSection from '@components/sections/WhyRideSection';
import FleetSection from '@components/sections/FleetSection';
import PricingSection from '@components/sections/PricingSection';
import ContactSection from '@components/sections/ContactSection';
import ResourcesSection from '@components/sections/ResourcesSection';
import QuoteModal from '@components/features/QuoteModal';
import { useModal } from '@hooks/useModal';

function App() {
  const { isOpen, open, close } = useModal();

  const handleBookNowClick = () => {
    open();
  };

  const handleRequestQuoteClick = () => {
    open();
  };

  return (
    <>
      <Layout onBookNowClick={handleBookNowClick}>
        <HeroSection onBookNowClick={handleBookNowClick} />
        <FeaturesBar />
        <WhyRideSection />
        <FleetSection onBookNowClick={handleBookNowClick} />
        <PricingSection />
        <ContactSection onRequestQuoteClick={handleRequestQuoteClick} />
        <ResourcesSection />
      </Layout>
      <QuoteModal isOpen={isOpen} onClose={close} />
    </>
  );
}

export default App;